import React from 'react';
import { type VariantProps } from 'class-variance-authority';
import Slot from '@/components/ui/Slot';
import cn from '@/utils/cn';
import {
  defaultTagForVariant,
  FontWeight,
  spacingVariants,
  textVariants,
  weightVariants,
} from '@/components/ui/Text/Text.utils';

interface TextProps extends VariantProps<typeof textVariants> {
  asChild?: boolean;
  children?: React.ReactNode;
  className?: string;
  size?: 'lg' | 'sm' | 'xl' | 'xs';
  spacing?: 'lg' | 'sm';
  tag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'div' | 'span' | 'label';
  weight?: FontWeight;
}

const Text = ({
  asChild,
  children,
  className,
  size,
  spacing,
  tag,
  variant,
  weight,
}: TextProps) => {
  const Component = asChild ? Slot : (tag || defaultTagForVariant(variant));

  return (
    <Component
      className={cn(
        textVariants({ size, variant }),
        spacingVariants({ spacing }),
        weightVariants({ weight }),
        className,
      )}
    >
      {children}
    </Component>
  );
};

export default Text;
